import { Button, Grid } from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import useChecklists from 'containers/pages/checklists/hooks/useChecklists';
import CustSelector from 'containers/pages/checklists/components/custSelector/CustSelector';
import AddrSelector from 'containers/pages/checklists/components/custSelector/AddrSelector';
import styles from './Checklists.module.css';
import ChecklistTable from 'containers/pages/checklists/components/checklistTable/ChecklistTable';
import ChecklistSearch from 'containers/pages/checklists/components/checklistSearch/ChecklistSearch';
import ChecklistTypeSelector from 'containers/pages/checklists/components/custSelector/ChecklistTypeSelector';

const Checklists = () => {
	const state = useChecklists();

	// if (alert.isAlert) return <ErrorMsg />;

	return (
		<>
			<Grid container p={1} justify="center">
				<Grid
					item
					xs={12}
					className={styles.wrap_checklist_type_selector}
				>
					<ChecklistTypeSelector
						checklistType={state.checklistType}
						setChecklistType={state.setChecklistType}
					/>
				</Grid>

				<Grid item xs={12} md={6}>
					<CustSelector setCustomerID={state.setCustomerID} />
				</Grid>
				<Grid item xs={12} md={6}>
					<AddrSelector
						addresses={state.addresses}
						setAddressID={state.setAddressID}
						customerId={state.customerID}
					/>
				</Grid>
				<Grid item xs={12} md={12} className={styles.wrap_items}>
					<Button
						disabled={state.checkDisableAddChecklist()}
						variant="contained"
						color="sds"
						onClick={state.onClickNewChecklist}
						startIcon={
							state.openNewChecklist ? (
								<RemoveIcon />
							) : (
								<AddIcon />
							)
						}
					>
						{state.checklistType} CHECKLIST
					</Button>
					<ChecklistSearch
						searchInput={state.searchInput}
						setSearchInput={state.setSearchInput}
					/>
				</Grid>
				<Grid item xs={12}>
					<ChecklistTable
						openNewChecklist={state.openNewChecklist}
						setAlert={state.setAlert}
						customerID={state.customerID}
						addressID={state.addressID}
						checklistType={state.checklistType}
						searchInput={state.searchInput}
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default Checklists;
